import { FormattedMessage } from 'react-intl';

const prefix = 'unauthorizedErrorPage';
export function UnauthorizedErrorPage() {
  const header = (
    <FormattedMessage id={`${prefix}.errorMessage`} defaultMessage="You do not have access to view this." />
  );
  const subheader = (
    <FormattedMessage
      id={`${prefix}.errorDescription`}
      defaultMessage="We are sorry, but you do not have authorization to view this page."
    />
  );
  const image = '/code-expired.svg';

  return (
    <div className="view-error-page">
      <div className="content">
        <div className="center aligned custom-icon">
          <img className="ui centered small image error-image" src={image} alt="unlink" />
        </div>
      </div>
      <div className="ui hidden divider"></div>
      <div className="custom-header mark">{header}</div>
      <div className="description">
        <p> {subheader}</p>
      </div>
    </div>
  );
}
